export function getLabel(name, pairs) {
    const find = pairs.find(g => g.name === name);
    return find ? find.label : undefined;
}
export const FieldLabels = [
    { name: 'firstName', label: 'First name' },
    { name: 'lastName', label: 'Last name' },
    { name: 'email', label: 'Email address' },
    { name: 'phoneNumber', label: 'Phone number' },
    { name: 'birthDate', label: 'Birth date' },
    { name: 'gender', label: 'Gender' },
    { name: 'timezone', label: 'Time zone' },
    { name: 'existingWeight', label: 'Existing weight' },
    { name: 'idealWeight', label: 'Ideal weight' },
    { name: 'heightDisplay', label: 'Height' },
    { name: 'eatOutCount', label: 'How many times do you eat out a week?' },
    { name: 'programType', label: 'Program type' },
];
export const YesNoLabels = [
    { name: 'selfCook', label: 'Do you cook?' },
    { name: 'elseCook', label: 'Does someone else cook for you?' },
    { name: 'mealPrep', label: 'Can you do simple meal prep?' },
];
export const DescLabels = [
    {
        name: 'outcomeDesc',
        label: 'What purposes do you have for doing the program and what is the expected time frame?',
    },
    { name: 'weightToLoseDesc', label: 'What is your first weight-loss goal?' },
    { name: 'allergiesDesc', label: 'Are you allergic to any foods?' },
    {
        name: 'sugarDesc',
        label: 'Do you currently use white sugar or a sugar substitute? if yes, what kind?',
    },
    {
        name: 'exerciseDesc',
        label: 'Do you exercise? If no, would you like to? If yes, what exercises do you do?',
    },
    { name: 'restrictionsDesc', label: 'Do you have any dietary preferences?' },
    { name: 'currentDietDesc', label: 'Are you currently on a meal / diet plan?' },
    { name: 'alcoholsDesc', label: 'Do you drink alcohol?' },
    { name: 'weekendMealsDesc', label: 'xWeekend Meals' },
    {
        name: 'cheatDesc',
        label: 'What are your cheat or reward foods you tend to overeat?',
    },
    {
        name: 'dietSuccessDesc',
        label: 'What diet has been most successful for you? Least successful? What happened?',
    },
    { name: 'medicationsDesc', label: 'What medications are you taking?' },
    { name: 'surgeriesDesc', label: 'Have you had any weight loss surgery?' },
    {
        name: 'breakfastDesc',
        label: 'What do you currently eat on weekdays for breakfast?',
    },
    {
        name: 'lunchDesc',
        label: 'What do you currently eat on weekdays for lunch?',
    },
    {
        name: 'dinnerDesc',
        label: 'What do you currently eat on weekdays for dinner?',
    },
    {
        name: 'snacksDesc',
        label: 'What do you currently eat on weekdays for snacks?',
    },
    { name: 'sourceDesc', label: 'Where did you hear about us?' },
];
export const Goals = [
    { name: 'LoseWeight', label: 'lose weight' },
    { name: 'Doctor', label: 'Dr. recommended I lose weight' },
    { name: 'HelpHealthIssues', label: 'help with health issues' },
    { name: 'LowerA1C', label: 'lower A1-C' },
    { name: 'LowerCholesterol', label: 'lower cholesterol' },
    { name: 'LowerBloodPressure', label: 'lower blood pressure' },
    { name: 'EaseJointPain', label: 'ease joint pain, inflammation' },
    { name: 'BetterSleep', label: 'better sleep' },
    { name: 'BetterMobility', label: 'better mobility' },
    { name: 'MaintainWeight', label: 'maintain weight' },
    { name: 'DecreaseWaistline', label: 'decrease my waistline' },
    { name: 'HandleLoveHandles', label: 'handle the love handles' },
    { name: 'DecreaseBellyFat', label: 'decrease belly fat' },
    { name: 'LookBetterInClothes', label: 'look better in clothes again' },
    { name: 'NoLargerSizes', label: 'not have to buy larger sizes' },
    { name: 'ComfortableWeight', label: 'be a comfortable weight for me' },
    { name: 'LookGoodInPictures', label: 'look good in pictures' },
    {
        name: 'LookGoodSpecialEvent',
        label: 'look good for a special event coming up',
    },
    { name: 'HaveMoreEnergy', label: 'have more energy' },
    { name: 'FeelBetterSelf', label: 'feel better about myself' },
    { name: 'FeelBetterOverall', label: 'feel better overall' },
];
// Generic helper function
const filterFieldsByPrefix = (values, prefix) => {
    const result = Object.entries(values).reduce((acc, [key, value]) => {
        if (key.startsWith(prefix) && typeof value === 'boolean') {
            acc[key] = value; // Here, 'acc' is a BooleanMap and mutable.
        }
        return acc;
    }, {});
    return result;
};
export const BeverageValuePrefix = 'beverage-';
export const DislikeValuePrefix = 'dislike-';
export const GoalValuePrefix = 'goal-';
// Specific helpers leveraging the generic function
export const beverageValues = (values) => filterFieldsByPrefix(values, BeverageValuePrefix);
export const dislikeValues = (values) => filterFieldsByPrefix(values, DislikeValuePrefix);
export const goalValues = (values) => filterFieldsByPrefix(values, GoalValuePrefix);
